/**
 * Размер и количество файлов — человекочитаемо.
 *
 * Потолок держим синхронно с бэкендом: без предупреждения в форме юрист
 * заливает комплект целиком и только в конце получает 413.
 */

/**
 * Потолок одного запроса. Держим равным `MAX_UPLOAD_BODY_BYTES` в
 * `routes/statut.rs` и `client_max_body_size` у nginx — если фронт занизит,
 * комплект уедет лишними частями; если завысит, юрист получит 413 после
 * долгой заливки.
 */
export const MAX_UPLOAD_BYTES = 200 * 1024 * 1024;

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} Б`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} КБ`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} МБ`;
  return `${(bytes / 1024 / 1024 / 1024).toFixed(2)} ГБ`;
}

/**
 * Русское склонение по числу: `pluralizeRu(2, ['файл', 'файла', 'файлов'])`.
 * Формы — именительный ед., родительный ед., родительный мн.
 */
export function pluralizeRu(n: number, forms: readonly [string, string, string]): string {
  const abs = Math.abs(n) % 100;
  const last = abs % 10;
  if (abs > 10 && abs < 20) return forms[2];
  if (last > 1 && last < 5) return forms[1];
  if (last === 1) return forms[0];
  return forms[2];
}

const FILE_FORMS = ['файл', 'файла', 'файлов'] as const;

/** `210` → `«210 файлов»`. */
export function formatFileCount(n: number): string {
  return `${n} ${pluralizeRu(n, FILE_FORMS)}`;
}

export const totalSize = (files: readonly File[]): number =>
  files.reduce((sum, f) => sum + f.size, 0);
